/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getFileUploads = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'upload_date',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 File Upload Management query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-file-upload-management/get?${queryString}`);
};

export const getFileUploadStats = () => {
  return API.get(`${getApiUrl()}/api/tkt1-file-upload-management/stats`);
};

export const searchFileUploads = (query) => {
  return API.get(`${getApiUrl()}/api/tkt1-file-upload-management/search`, { params: query });
};

export const getFileUploadByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-file-upload-management/${id}`);
};

export const updateFileUpload = (id, fileData) => {
  return API.put(`${getApiUrl()}/api/tkt1-file-upload-management/${id}`, fileData);
};

export const deleteFileUpload = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-file-upload-management/${id}`);
};

export const createFileUpload = (fileData) => {
  return API.post(`${getApiUrl()}/api/tkt1-file-upload-management/create`, fileData);
};

export const tkt1FileUploadManagementService = {
  getFileUploads,
  getFileUploadStats,
  searchFileUploads,
  getFileUploadByID,
  updateFileUpload,
  deleteFileUpload,
  createFileUpload
};
